module.exports = __webpack_public_path__ + "img/wjgs.93178097.svg";